// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18 16H16V22H22V16H20V11.3333H13L13 8H15V2L9 2L9 8H11L11 11.3333L4 11.3333L4 16L2 16L2 22H8L8 16H6V13.3333L18 13.3333V16Z"}}]};

const TreeSquareDotFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tree-square-dot-filled',
    ref,
    icon: element,
  },
));

TreeSquareDotFilledIcon.displayName = 'TreeSquareDotFilledIcon';

export default TreeSquareDotFilledIcon;
